import { render } from "./HomeCatalog.vue?vue&type=template&id=fef709f8&scoped=true"
import script from "./HomeCatalog.vue?vue&type=script&lang=js"
export * from "./HomeCatalog.vue?vue&type=script&lang=js"

import "./HomeCatalog.vue?vue&type=style&index=0&id=fef709f8&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-fef709f8"

export default script